import type { InstructorStat } from "../../api/stats/Stats.typed";

function capitalizeSegment(seg: string): string {
  if (!seg) return "";
  return seg.charAt(0).toUpperCase() + seg.slice(1).toLowerCase();
}

function formatNamePart(part: string): string {
  return part
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) =>
      word
        .split("-")
        .map((piece) => capitalizeSegment(piece))
        .join("-"),
    )
    .filter(Boolean)
    .join(" ");
}

/** Unlinked history rows share id 0, so they are told apart by external_id. */
export function instructorStatKey(r: Pick<InstructorStat, "id" | "external_id">): string {
  return r.id > 0 ? `u${r.id}` : `x${r.external_id ?? 0}`;
}

export function formatInstructorStatDisplayName(
  r: Pick<InstructorStat, "id" | "first_name" | "last_name">,
): string {
  const first = formatNamePart(r.first_name);
  const last = formatNamePart(r.last_name);
  const n = `${first} ${last}`.trim();
  return n || `Utilisateur #${r.id}`;
}
